/**
 * @file verificationResend.js
 * @description What happened when someone asked send-verification-email for a fresh link, read in one place for the
 *   two screens that ask (EmailVerificationPending for the user, WorkersTab for an admin). The server side is
 *   supabase/functions/send-verification-email/handler.ts: a link is allowed once per minute, and the refusal is a
 *   429 { ok:false, reason:"rate_limited", wait_seconds }. supabase-js hands a 429 over as an error with data null,
 *   so the status and the body come from the error (functionErrorMessage.js), not from res.data.
 *
 *     verificationResendOutcome(res) -> { kind: "sent" }
 *                                     | { kind: "cooldown", waitSeconds: number|null }   a link went out a moment ago
 *                                     | { kind: "error", message }                       message may be ""
 * @module lib/verificationResend
 */
import { functionReply } from "./functionErrorMessage";

/** @param {{ data?: any, error?: Error|null }} res what supabase.functions.invoke returned */
export async function verificationResendOutcome(res) {
  const { body, status, message } = await functionReply(res);
  if (status === 429 || body?.reason === "rate_limited") {
    return { kind: "cooldown", waitSeconds: Number.isFinite(body?.wait_seconds) ? body.wait_seconds : null };
  }
  if (res?.error) return { kind: "error", message };
  if (body?.ok) return { kind: "sent" };
  return { kind: "error", message: message || "" };
}
